import React, { useContext } from "react";
import { Typography } from "mobily-ui-library";

import "./OrderSummary.scss";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../context/GlobalContext";



interface Product {
    name: string;
    price: string;
    unit?: string;
}

interface OrderSummaryProps {
    products: Product[];
    orderPriceData: any;
    rtl: boolean;
    ftiMonthlyCommitmentAmt?: string;
    ftiPromotionCommitmentPeriod?: string;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ rtl, products, orderPriceData, ftiMonthlyCommitmentAmt, ftiPromotionCommitmentPeriod }) => {
    const { t } = useTranslation();
    const { state }: any = useContext(GlobalContext);
    const { isFTIApplied } = state;

    return (
        <div className="CartPage__OrderSummary">
            <div className="CartPage__Payments">
                <>
                    {products.map((product: any, index: any) => (
                        <div id={product?.id} className="Payments__Item" key={index}>
                            <Typography rtl={rtl} className="CPI__Name">{product?.name}</Typography>
                            <Typography rtl={rtl} className="CPI__Price">
                                {String(product?.price).startsWith('-') ? (
                                    <>-<span className="unit">{t("SAR")}&nbsp;</span>{String(product?.price).slice(1)}</>) : (
                                    <><span className="unit">{t("SAR")}&nbsp;</span>{product?.price} </>
                                )}
                            </Typography>
                        </div>
                    ))}
                    <div className="line"></div>
                    <div className="Payments__Total">
                        <Typography rtl={rtl} className="CPI__Total">{t("Total")}</Typography>
                        <div className="CPIT">
                            <Typography rtl={rtl} className="CPI__TotalPrice">
                                <span className='unit'>{t("SAR")}&nbsp;</span>
                                {orderPriceData?.taxIncludedAlteredAmount?.value}
                            </Typography>
                            <Typography rtl={rtl} className="CPI__VAT">{t("Incl_15%_VAT")}</Typography>
                        </div>
                    </div>

                    {
                        isFTIApplied && (
                            <div id="Total_Month_instalment" className="Payments__Item" key="Total_Month_instalment">
                                <Typography rtl={rtl} className="CPI__Name">{t("Total_Month_instalment")}</Typography>
                                <div className="CPIT">
                                    <Typography className="CPI__Price">
                                        <span className="unit">{t("SAR")}&nbsp;</span>{ftiMonthlyCommitmentAmt} / {ftiPromotionCommitmentPeriod}{t("Months")}
                                    </Typography>
                                    <Typography className="CPI__VAT CPI__VAT_plus">{t("Incl_15%_VAT")}</Typography>
                                </div>
                            </div>
                        )
                    }
                </>
            </div>
        </div>
    )
}

export default OrderSummary